var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87438",
    "data-name": "Group 87438",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.099,
    height: 24.597,
    viewBox: "0 0 22.099 24.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87439",
    "data-name": "Group 87439",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87440",
    "data-name": "Group 87440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275629",
    "data-name": "Path 275629",
    d: "M1.047,24.175l.064.077.55-2.549,1.516,1.529-.587.533-.929.246Z",
    transform: "translate(-0.132 -2.828)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275624",
    "data-name": "Path 275624",
    d: "M64.814,108.123l-3.49-3.49L50.151,115.805l.1.057a2.358,2.358,0,0,1,1.668,1.668,2.358,2.358,0,0,1,1.668,1.668l.033.122Z",
    transform: "translate(-47.742 -99.606)",
    fill: "#ffded7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275625",
    "data-name": "Path 275625",
    d: "M.48,22.1a.48.48,0,0,1-.464-.6l1.261-4.751a.48.48,0,0,1,.125-.217L17.488.441a1.512,1.512,0,0,1,2.134,0l2.036,2.036a1.512,1.512,0,0,1,0,2.134L5.57,20.7a.481.481,0,0,1-.217.125L.6,22.083A.48.48,0,0,1,.48,22.1m1.692-4.983L1.156,20.942l3.826-1.015,16-16a.551.551,0,0,0,0-.775L18.942,1.12a.551.551,0,0,0-.775,0Zm3.059,3.242h0Z",
    transform: "translate(0.001 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275626",
    "data-name": "Path 275626",
    d: "M21.618,492.962H.48a.48.48,0,0,1,0-.961H21.618a.48.48,0,0,1,0,.961",
    transform: "translate(0 -468.365)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275627",
    "data-name": "Path 275627",
    d: "M315.239,66.924a.479.479,0,0,1-.34-.141l-3.15-3.15a.48.48,0,0,1,.679-.679l3.15,3.15a.48.48,0,0,1-.34.82",
    transform: "translate(-296.639 -59.796)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275628",
    "data-name": "Path 275628",
    d: "M21.58,381.505a.48.48,0,0,1-.464-.356,2.4,2.4,0,0,0-1.7-1.7.48.48,0,0,1,.249-.928,3.363,3.363,0,0,1,2.378,2.378.481.481,0,0,1-.464.6",
    transform: "translate(-18.146 -360.322)",
    fill: "#515255"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/Edit_Pen.974bc4b83ba1403860836b0603154b4f.svg";
export { ForwardRef as ReactComponent };